'use client'

import { format } from 'date-fns'
import { Calendar, ChevronRight } from 'react-feather'
import { useRouter, useTranslations } from '@/lib/next-shim'
import { StatusBadge } from '@/components/ui/StatusBadge'
import { ExpertiseConsultation } from '../lib/expertise-detail.types'

type ConsultationsSectionProps = {
  consultations: ExpertiseConsultation[]
}

export function ConsultationsSection({ consultations }: ConsultationsSectionProps) {
  const t = useTranslations()
  const router = useRouter()

  if (!consultations.length) return null

  return (
    <div>
      <h2 className="mb-2 text-sm font-medium text-gray-500">{t('account.expertises.consultations')}</h2>
      <div className="rounded-xl border border-gray-200 bg-white p-4">
        <ul className="space-y-1">
          {consultations.map((consultation) => (
            <li key={consultation._id}>
              <button
                type="button"
                onClick={() => router.push(`/account/consultations/${consultation._id}`)}
                className="flex w-full items-center justify-between gap-2 rounded-lg px-2 py-1.5 text-left transition-colors hover:bg-gray-50"
              >
                <span className="flex min-w-0 flex-1 items-center gap-2">
                  <Calendar size={16} className="shrink-0 text-primary" aria-hidden="true" />
                  <span className="min-w-0">
                    <span className="block truncate text-sm text-gray-900">{format(new Date(consultation.startDate), 'PPp')}</span>
                    {consultation.speciality && <span className="block truncate text-xs capitalize text-gray-500">{consultation.speciality}</span>}
                  </span>
                </span>
                <span className="flex shrink-0 items-center gap-2">
                  <StatusBadge status={consultation.status} statusText={t(`model.consultation.status.${consultation.status.toLowerCase()}`)} />
                  <ChevronRight size={16} className="text-gray-400" aria-hidden="true" />
                </span>
              </button>
            </li>
          ))}
        </ul>
      </div>
    </div>
  )
}
